'use client';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { ELIGIBILITY_CRITERIA } from '../../constants';

import styles from './styles.module.css';

import { ContentSegment } from '@/components/ContentSegment';

export function Eligibility() {
  const t = useTranslations('topSellerProgram');

  return (
    <section className={styles.section}>
      <ContentSegment reverse>
        <ContentSegment.Image>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src={`${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/topSellerProgram/girl-holding-phone.webp`}
              alt={t('Eligibility.ImageAlt')}
            />
          </div>
        </ContentSegment.Image>
        <ContentSegment.Content>
          <ContentSegment.Title variant="lg">
            {t('Eligibility.Heading')}
          </ContentSegment.Title>
          <Body variant="sm-regular" className={styles.description}>
            {t('Eligibility.Description')}
          </Body>
          <ul className={styles.criteriaList}>
            {ELIGIBILITY_CRITERIA.map(
              ({ icon: Icon, titleKey, descriptionKey }) => (
                <li key={titleKey} className={styles.criterionItem}>
                  <div className={styles.iconWrapper}>
                    <Icon size="md" />
                  </div>
                  <div className={styles.criterionText}>
                    <Heading variant="md" as="h3">
                      {t(titleKey)}
                    </Heading>
                    <Body variant="sm-regular">{t(descriptionKey)}</Body>
                  </div>
                </li>
              )
            )}
          </ul>
        </ContentSegment.Content>
      </ContentSegment>
    </section>
  );
}
